module.exports = __webpack_public_path__ + "static/img/part2.32b0400.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/part2.png
// module id = IWxZ
// module chunks = 1